import axios from 'axios';
import jwtDecode from 'jwt-decode';
import BaseSource, { AVAILABLE_COLLECTION_TYPES } from 'sources/baseSource';
import Role from 'types/Role';
import RoleSourceType from 'sources/sourceTypes/Role';
import * as mapper from 'sources/mapper/Role';
import { setDomain, getToken } from 'utils/auth';

// Add more claims when needed
type JWTClaims = {
  sub: number;
};

class AuthSource extends BaseSource<Role, RoleSourceType, {}> {
  public ObjectURL = 'auth' as AVAILABLE_COLLECTION_TYPES;

  public toSource = mapper.toSource;

  public toType = mapper.toType;

  public async authenticate(
    email: string,
    password: string,
    code: string
  ): Promise<string> {
    setDomain(code);

    const authorizationString = `Basic ${btoa(`${email}:${password}`)}`;
    const response = await axios.get<string>(this.Url, {
      headers: { Authorization: authorizationString },
    });

    return response.data;
  }

  async roles(): Promise<Role[]> {
    const token = getToken();
    if (token) {
      const { sub } = jwtDecode(token) as JWTClaims;
      const { data } = await axios.get<{ roles: RoleSourceType[] }>(
        `${this.baseUrl}/api/users/${sub}/roles`,
        this.headers
      );
      const roles = data.roles
        .filter(source => source.role_type !== 'Client')
        .map(source => this.toType(source));
      return roles;
    }
    return [];
  }
}

const authSource = new AuthSource();

export default authSource;
